import { render, staticRenderFns } from "./MedicationForm.vue?vue&type=template&id=17a8350e&scoped=true"
import script from "./MedicationForm.vue?vue&type=script&lang=js"
export * from "./MedicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8350e",
  null
  
)

export default component.exports